export { default } from './DisclaimerText';
